import React, { Component } from "react";

class PageNotFound extends Component {
  state = {};
  render() {
    return <h4 className="align-center">404 Page Not Found</h4>;
  }
}

export default PageNotFound;



// WEBPACK FOOTER //
// ./src/views/pageNotFound.jsx